import type { SaleData } from '@features/sale/sale-auction';

export function checkIsWalletBestBidder(bestBid: SaleData['bestBid'], userWalletAddress: string | undefined) {
  if (!bestBid || !userWalletAddress) {
    return false;
  }

  const normalizedBidderWallet = bestBid.wallet.toLowerCase();
  const normalizedUserWallet = userWalletAddress.toLowerCase();

  return normalizedBidderWallet === normalizedUserWallet;
}
